<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   
           </div>
        </div>
    </div>
    <div class="academy-hero-bottom-section">
        <div class="container">
            <div class="academy-visio-section">
                <div class="academy-visio-box" *ngFor="let vision of academytList?.data?.missionvision">
                    <div class="academy-visio-image">
                       <img [src]="vision?.image">
                    </div>
                    <div class="academy-visio-content">
                        <div class="academy-visio-titel">
                            <h2 class="titel-name">{{vision?.title}} </h2>
                        </div>
                        <div class="academy-visio-text" [innerHTML]="vision?.description">
                           <p>To provide young, local Leicestershire Cricketers with the opportunities to play First Class and International Cricket </p>
                        </div>
                    </div>
                </div>  
                <!-- <div class="academy-visio-box">
                    <div class="academy-visio-image">
                       <img src="assets/images/vison-ic.svg">
                    </div>
                    <div class="academy-visio-content">
                        <div class="academy-visio-titel">
                            <h2 class="titel-name">Our Mission</h2>
                        </div>
                        <div class="academy-visio-text">
                            <p>Aim to provide an oversupply of cricketers who can challenge the current standards set within the Leicestershire CCC First team squad. </p>
                        </div>
                    </div>
                </div>   -->
            </div>
            <div class="museum-sub-committe-section cf"  *ngIf="scholarstList">
                <div class="titel-box">
                    <h2 class="titel-name">{{scholarstList?.title}}</h2>
                </div>
                <div class="sub-committe-detail cf">
                    <div class="player-staff-box" *ngFor="let scholars of scholarstList?.academy_general_image">
                        <a href="javascript:void(0)">
                            <img *ngIf="scholars?.image" [src]="scholars?.image">
                            <div class="player-staff-box-overlay" *ngIf="scholars?.name">
                                <h4>{{scholars?.name}}</h4>
                            </div>
                        </a>
                    </div>
                    
                </div>
            </div>
            <div class="academy-our-strategy" *ngIf="strategytList">
                <div class="academy-our-strategy-top">
                    <div class="academy-our-strategy-top-titel">
                        <h2 class="titel-name">{{strategytList?.title}}</h2>
                    </div>
                    <div class="academy-our-strategy-top-sub-titel" [innerHTML]="strategytList?.description">
                        <h3>Achieving the ‘Gold Fox Standard’</h3>
                    </div>
                    <!-- <div class="academy-our-strategy-top-content">
                        <p>The team of dedicated coaches focus on what players can do, not what they can’t and prioritise skills over techniques. Coaching is supplied to be age and stage specific with opportunities provided for players to be challenged to improve and even excel.</p>
                    </div> -->
                </div>
                <div class="academy-our-strategy-bottom" *ngIf="strategytList?.academy_general_video">
                    <div class="community-cricket-video">
                        <div class="community-cricket-video-box " *ngFor="let videos of strategytList?.academy_general_video">
                            <img *ngIf="videos?.image" [src]="videos?.image" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text" *ngIf="videos?.title">
                                        <p>{{videos?.title}}</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn" *ngIf="videos?.video && videos?.type== 'Local'">
                                        <a href="{{videos?.video}}" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="community-cricket-video-box ">
                            <img src="assets/images/1607975006_player-sponsorship.jpg" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text">
                                        <p>Leaping into Monday like...</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn">
                                        <a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="community-cricket-video-box ">
                            <img src="assets/images/1607975006_player-sponsorship.jpg" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text">
                                        <p>Leaping into Monday like...</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn">
                                        <a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="academy-graduates" *ngIf="graduatesList">
                <div class="academy-graduates-top">
                    <div class="academy-our-strategy-top-titel">
                        <h2 class="titel-name">{{graduatesList?.title}}</h2>
                    </div>
                    <div class="academy-our-strategy-top-content" [innerHTML]="graduatesList?.description">
                        <p>Over the years, the Leicestershire CCC Academy has produced cricket talent who have gone on to play First Class Cricket and International cricket. </p>
                    </div>
                </div>
                <div class="academy-graduates-bottom" *ngIf="graduatesList?.academy_general_image">
                    <div class="sub-committe-detail cf">
                        <ngx-slick-carousel class="carousel" slickModal="slick-carousel"[config]="slideplayerConfig">
                            <div ngxSlickItem class="player-staff-box slide" *ngFor="let graduates of graduatesList?.academy_general_image">
                                <a href="javascript:void(0)">
                                    <img [src]="graduates?.image">
                                    <div class="player-staff-box-overlay">
                                        <h4>{{graduates?.name}}</h4>
                                        <p>{{graduates?.designation}}</p>
                                    </div>
                                    <!-- <div class="player-staff-box-text" [innerHTML]="committe?.description">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div> -->
                                </a>
                            </div>
                           
                        </ngx-slick-carousel>   
                    </div>
                </div>
            </div>
            <div class="academy-cricket-sponsor" *ngIf="sponsorList">
                <div class="academy-our-strategy-top-titel">
                    <h2 class="titel-name">{{sponsorList?.title}}</h2>
                </div>
                <div class="academy-cricket-sponsor-bottom">
                    <div class="academy-cricket-sponsor-detail">
                        <div class="academy-cricket-sponsor-image" *ngIf="sponsorList?.image">
                            <div class="academy-cricket-sponsor-image-inner">
                                <img [src]="sponsorList?.image">
                            </div> 
                        </div>
                        <div class="academy-cricket-sponsor-content" [innerHTML]="sponsorList?.description">
                            <p>For the 2021 season, the Academy of Cricket of proudly sponsored by The Melton Building Society</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->